import { TypeOfIncome } from 'projects/borrower-app/src/app/models/enums/type-of-income.enum';
import { IncomeStepConfig } from 'projects/borrower-app/src/app/models/wizard/config/income-step-config.model';

export interface IncomeCategoryOption {
  value: TypeOfIncome;
  /** Same lender-editable config label the desktop tiles use. */
  labelField: keyof IncomeStepConfig & string;
  /** Per-language default when the lender has not customized the label. */
  i18nKey: string;
}

export const INCOME_CATEGORY_OPTIONS: readonly IncomeCategoryOption[] = [
  { value: TypeOfIncome.Base, labelField: 'w2EmploymentActionLabel', i18nKey: 'wizard.income.employmentW2' },
  { value: TypeOfIncome.ContractBasis, labelField: 'independentContractorActionLabel', i18nKey: 'wizard.income.independentContractor' },
  { value: TypeOfIncome.MilitaryBasePay, labelField: 'militaryPayActionLabel', i18nKey: 'wizard.income.militaryPay' },
  { value: TypeOfIncome.NetRentalIncome, labelField: 'rentalIncomeActionLabel', i18nKey: 'wizard.income.rental' },
  { value: TypeOfIncome.SocialSecurity, labelField: 'socialSecurityIncomeActionLabel', i18nKey: 'wizard.income.socialSecurity' },
  { value: TypeOfIncome.Pension, labelField: 'pensionIncomeActionLabel', i18nKey: 'wizard.income.pension' },
  { value: TypeOfIncome.SelfEmploymentIncome, labelField: 'businessSelfEmploymentActionLabel', i18nKey: 'wizard.income.businessSelfEmployment' },
  { value: TypeOfIncome.OtherTypesOfIncome, labelField: 'otherIncomeActionLabel', i18nKey: 'wizard.income.other' },
];
